import {
  MultiSheetMenuItem,
  MultiSheetMenuItemProps,
} from "@/components/ui/multi-sheet-menu/multi-sheet-menu-item";
import { Features, selectHasFeature } from "@/store/features/features-slice";
import { useAppDispatch, useAppSelector } from "@/store/store-hooks";
import { selectShowDynamicOverviewMap } from "@/store/view-options/view-options-selectors";
import { setShowDynamicOverviewMap } from "@/store/view-options/view-options-slice";
import { type JSX } from "react";
import { selectDynamicMapForSheet } from "./dynamic-map-selectors";

/**
 * @returns the menu item of a sheet, preceded by the one of its dynamic map if available.
 * Both items show the same sheet, the dynamic or the static rendering of it, so only one of them can be visible.
 * @param props of the sheet menu item
 */
export function DynamicMapMenuItems(
  props: MultiSheetMenuItemProps,
): JSX.Element {
  const { sheet, isVisible, onElementClicked, onEyeClicked } = props;
  const dispatch = useAppDispatch();
  const dynamicMap = useAppSelector((state) =>
    selectHasFeature(Features.DynamicOverviewMap)(state)
      ? selectDynamicMapForSheet(sheet)(state)
      : undefined,
  );
  const showDynamic = useAppSelector(selectShowDynamicOverviewMap);

  if (!dynamicMap) return <MultiSheetMenuItem {...props} />;

  function itemProps(dynamic: boolean): MultiSheetMenuItemProps {
    return {
      ...props,
      dynamicMap: dynamic ? dynamicMap : undefined,
      isVisible: isVisible && showDynamic === dynamic,
      onElementClicked(id) {
        dispatch(setShowDynamicOverviewMap(dynamic));
        onElementClicked(id);
      },
      onEyeClicked(id, visible) {
        if (visible) dispatch(setShowDynamicOverviewMap(dynamic));
        onEyeClicked(id, visible);
      },
    };
  }

  return (
    <>
      <MultiSheetMenuItem {...itemProps(true)} />
      <MultiSheetMenuItem {...itemProps(false)} />
    </>
  );
}
